module.exports = __webpack_public_path__ + "static/img/meuvivo.d2c2613.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/analise/meuvivo.gif
// module id = lHCY
// module chunks = 2